import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.page.html',
  styleUrls: ['./admin-users.page.scss'],
})
export class AdminUsersPage implements OnInit {

  constructor(
    private menu: MenuController,
    private router: Router
  ) { }

  ngOnInit() {
  }

  openAdmin(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  home(){
    this.router.navigate(['admin-home']);
  }
  users(){
    this.router.navigate(['admin-users']);
  }

  edit(){
    this.router.navigate(['admin-edit']);
  }

  logout(){
    this.router.navigate(['home/login']);
  }

}
